import React, { useContext } from 'react';
import { Grid } from '@mui/material';

import VendorSlider from './Slider/VendorSlider';

import VendorItem from './VendorItem';
import SellScreen from '../SellScreen/SellScreen';
import OcrScreen from '../OcrScreen/OrcScreen';
import PaymentScreen from '../PaymentScreen/PaymentScreen';
import PapirScreen from '../PapirScreen/PapirScreen';
import PapirScreenKingo from '../PapirScreenKingo/PapirScreenKingo';
import PapirScreenXtipp from '../PapirScreenXtipp/PapirScreenXtipp';
import FlaxScreen from '../Flax/FlaxScreen';

import { AppContext } from '../../../context/Context';

function Vendors() {
  const {
    isSellerOpen,
    isPapirOpen,
    isPaymentOpen,
    isOcrOpen,
    isPapirKingoOpen,
    isPapirXtippOpen,
    isFlaxOpen,
  } = useContext(AppContext);

  return (
    <>
      {!isSellerOpen && !isOcrOpen && !isPaymentOpen && (
        <>
          <Grid
            container
            flexDirection="row"
            sx={{
              height: 'calc(100% - 175px)',
              width: '100%',
              marginTop: 0,
              marginLeft: 0,
            }}
          >
            <VendorItem />
          </Grid>
          <VendorSlider />
        </>
      )}{' '}
      {isSellerOpen &&
        !isPapirOpen &&
        !isPapirKingoOpen &&
        !isPapirXtippOpen &&
        !isFlaxOpen && (
          <Grid
            container
            flexDirection="row"
            sx={{
              height: '100%',
              width: '100%',
              marginTop: 0,
              marginLeft: 0,
            }}
          >
            <SellScreen />
          </Grid>
        )}
      {isSellerOpen && isPapirOpen && (
        <Grid
          container
          flexDirection="row"
          sx={{
            height: '100%',
            width: '100%',
            marginTop: 0,
            marginLeft: 0,
          }}
        >
          <PapirScreen />
        </Grid>
      )}
      {isSellerOpen && isPapirKingoOpen && (
        <Grid
          container
          flexDirection="row"
          sx={{
            height: '100%',
            width: '100%',
            marginTop: 0,
            marginLeft: 0,
          }}
        >
          <PapirScreenKingo />
        </Grid>
      )}
      {isSellerOpen && isFlaxOpen && (
        <Grid
          container
          flexDirection="row"
          sx={{
            height: '100%',
            width: '100%',
            marginTop: 0,
            marginLeft: 0,
          }}
        >
          <FlaxScreen />
        </Grid>
      )}
      {isSellerOpen && isPapirXtippOpen && (
        <Grid
          container
          flexDirection="row"
          sx={{
            height: '100%',
            width: '100%',
            marginTop: 0,
            marginLeft: 0,
          }}
        >
          <PapirScreenXtipp />
        </Grid>
      )}
      {isOcrOpen && (
        <Grid
          container
          flexDirection="row"
          sx={{
            height: '100%',
            width: '100%',
            marginTop: 0,
            marginLeft: 0,
          }}
        >
          <OcrScreen />
        </Grid>
      )}
      {isPaymentOpen && (
        <Grid
          container
          flexDirection="row"
          sx={{
            height: '100%',
            width: '100%',
            marginTop: 0,
            marginLeft: 0,
          }}
        >
          <PaymentScreen />
        </Grid>
      )}
    </>
  );
}

export default Vendors;
